import { TagsInput as MTagsInput } from '@mantine/core';
import classes from './tagsInput.module.scss';
import { IconSelector } from '@tabler/icons-react';

export const TagsInput = MTagsInput.extend({
  classNames: classes,
  styles: {
    option: {
      padding: '0.75rem',
    },
  },
});

TagsInput.defaultProps = {
  rightSection: (
    <IconSelector size={20} color='var(--mantine-color-primary-7)' />
  ),
};
